export class APEventQueue<T> {
    private _events: T[] = [];
    private _timer: ReturnType<typeof setTimeout> | null = null;
    static TIMER_DELAY_DEFAULT = 1000;

    constructor(
        private executor: (items: T[]) => Promise<void>,
        private opts: { delay: number } = {
            delay: APEventQueue.TIMER_DELAY_DEFAULT,
        },
    ) {}

    get events() {
        return this._events;
    }

    find(predicate: (item: T, index: number) => boolean) {
        return this.events.find(predicate);
    }

    queue(item: T): void {
        this.events.push(item);
    }

    clear(): void {
        this._events = [];
    }

    resetTimer(): void {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    }

    startTimer(): void {
        this.resetTimer();

        this._timer = setTimeout(() => {
            this.flush();
        }, this.opts.delay);
    }

    flush(): void {
        if (this.events.length === 0) {
            return;
        }
        try {
            const eventsCloned = this.events.slice();
            this.clear();
            void this.executor(eventsCloned);
        } catch {
            // catch errors to avoid breaking the flow
        }
    }
}
